export const globalAccount = 'Global Account 1';
